export const formatFileSize = (bytes) => {
    try {
        if (!bytes || bytes === 0) return '0 Bytes';
        const k = 1024;
        const sizes = ['Bytes', 'KB', 'MB', 'GB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
    } catch (error) {
        console.error('Error formatting file size:', error);
        return 'N/A';
    }
};

export const getStatusBadge = (status, movieId, fileErrors) => {
    const statusConfig = {
        'uploading': { color: 'primary', label: 'Uploading...' },
        'uploaded': { color: 'secondary', label: 'Uploaded' },
        'pcr_started': { color: 'primary', label: 'Analyzing PCR' },
        'full_pcr': { color: 'success', label: 'PCR Done' },
        'pcr_failed': { color: 'danger', label: 'PCR Failed' },
        'director_started': { color: 'primary', label: 'Analyzing (Full)' },
        'full_director': { color: 'dark', label: 'Director\'s Cut' },
        'full_failed': { color: 'danger', label: 'Full Analysis Failed' },
        'failed': { color: 'danger', label: 'Upload Failed' },
        'error': { color: 'danger', label: 'Error' },
    };

    const config = statusConfig[status] || '';
    const errorMessage = fileErrors[movieId];
    
    return (
        <span 
            className={`badge bg-${config.color}`}
            title={errorMessage || config.label}
            style={{ cursor: errorMessage ? 'help' : 'default' }}
        >
            {config.label}
        </span>
    );
};

export const getRowClassName = (movie) => {
    switch (movie.status) {
        case 'failed':
        case 'small_failed':
        case 'full_failed':
            return 'table-danger';
        case 'uploading':
            return 'table-info';
        case 'small_started':
        case 'full_started':
            return 'table-warning';
        case 'small_done':
        case 'full_done':
            return 'table-success';
        default:
            return '';
    }
};

export const getFileCountSummary = (movies) => {
    const total = movies.length;
    const uploaded = movies.filter(m => m.status === 'uploaded').length;
    const failed = movies.filter(m => m.status === 'failed' || (m.status && m.status.includes('_failed'))).length;
    const processing = movies.filter(m => m.status === 'uploading' || (m.status && m.status.includes('_started'))).length;
    const completed = movies.filter(m => m.status === 'full_done').length;

    return { total, uploaded, failed, processing, completed };
};